import { render, staticRenderFns } from "./Bando33Fase4.vue?vue&type=template&id=48ca9af3&scoped=true"
import script from "./Bando33Fase4.vue?vue&type=script&lang=js"
export * from "./Bando33Fase4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ca9af3",
  null
  
)

export default component.exports